import React, { FC } from 'react';
import clsx from 'clsx';
import { Box, Step, Stepper, StepLabel, makeStyles, Orientation } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';

export type GenericStepperProps = {
  totalSteps: number;
  stepperConfig: GenericObject[];
  totalStepsCompleted: number;
  size?: 'small' | 'large';
  ariaLabel?: string;
  dataTestID?: string;
  orientation?: Orientation;
  labelOrientation?: Orientation;
  hideInactiveLabelOnMobile?: boolean;
  hideStepperIndicatorOnStepIndex?: number[];
  externalStepperWrapperClasses?: string;
  externalStepperClasses?: string;
};

const useStepperStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(0),
    width: (props: any) => (props?.size === 'large' ? '100%' : 'auto'),
  },
}));
//TODO: add label orientation and conditionaly hide label on mobile
const GenericStepper: FC<GenericStepperProps> = ({
  stepperConfig,
  totalSteps,
  totalStepsCompleted,
  size = 'large',
  dataTestID = 'wizard-flow-stepper',
  ariaLabel,
  orientation = 'horizontal',
  labelOrientation = 'horizontal',
  hideInactiveLabelOnMobile = false,
  hideStepperIndicatorOnStepIndex,
  externalStepperWrapperClasses,
  externalStepperClasses,
}) => {
  const classes = useStepperStyles({ size });
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  if (hideStepperIndicatorOnStepIndex?.length) {
    const isStepperHiddenOnCurrentStep = hideStepperIndicatorOnStepIndex.find(index => index === totalStepsCompleted);
    if (isStepperHiddenOnCurrentStep) {
      return null;
    }
  }

  return (
    <Box py={3} display={'flex'} justifyContent={'center'} className={externalStepperWrapperClasses}>
      <Stepper
        aria-label={ariaLabel}
        data-testid={dataTestID}
        classes={{ root: clsx(classes.root, externalStepperClasses) }}
        orientation={orientation}
        activeStep={totalStepsCompleted}
        alternativeLabel={labelOrientation === 'vertical'}>
        {stepperConfig.map((step, index) => (
          <Step key={index} completed={index < totalStepsCompleted} active={index === totalStepsCompleted}>
            <StepLabel>
              {isMobile && hideInactiveLabelOnMobile && index !== totalStepsCompleted ? null : step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export { GenericStepper };
